var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"explain"},[_c('span',[_vm._v("登录/注册即视为您已阅读并同意易隆创")]),_c('span',{staticClass:"agreement",on:{"click":_vm.goServe}},[_vm._v("服务条款")]),_c('span',[_vm._v("和")]),_c('span',{staticClass:"agreement",on:{"click":_vm.goPolicy}},[_vm._v("隐私政策")])])
}
var staticRenderFns = []

export { render, staticRenderFns }